import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { Link } from 'react-router-dom';
import { fetchCollection, addTournamentToDb } from './utils';
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import Switch from "react-switch";
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';

function CreateTournament() {

    const navigate = useNavigate();
    // Values in the form:
    // Tournament Name
    // Men/Women
    // Level - Pro, Am, Junior, etc.
    // Type - Classification of tournament within each level
    // Association(s) - The associations running the tournament

    // Page status
    const [loading, setLoading] = useState(true)

    // user information
    const [userId, setUserId] = useState("")

    // Fetched from DB
    const [allLevels, setAllLevels] = useState([])
    const [allSublevels, setAllSubLevels] = useState([])
    const [allTournamentTypes, setAllTournamentTypes] = useState([])
    const [allAssociations, setAllAssociations] = useState([])
    const [allGolfCourses, setAllGolfCourses] = useState([])
    const [allTournaments, setAllTournaments] = useState([])

    // Values in the form
    const [tournamentName, setTournamentName] = useState("")
    const [menWomen, setMenWomen] = useState([])
    const [levels, setLevels] = useState([])
    const [subLevels, setSubLevels] = useState([])
    const [tournamentTypes, setTournamentTypes] = useState([])
    const [associations, setAssociations] = useState([])
    const [tournamentPage, setTournamentPage] = useState("")
    const [golfCourses, setGolfCourses] = useState([])
    const [startDate, startDateOnChange] = useState(new Date())
    const [endDate, endDateOnChange] = useState(new Date())
    const [signupEligibility, setSignupEligibility] = useState("")
    const [qualifierNeeded, setQualifierNeeded] = useState(false)
    const [otherSites, setOtherSites] = useState([])
    const [qualifierFor, setQualifierFor] = useState([])
    const [qualifiers, setQualifiers] = useState([])
    const [relatedTournaments, setRelatedTournaments] = useState([])

    const menWomenList = [{label: "Men", value: "Men"}, {label: "Women", value: "Women"}, {label: "Both", value: "Both"}]

    const handleQualifierNeededChange = (checked) => {
        setQualifierNeeded(checked)
    }

    const fetchData = async () => {

        // Fetch user information from firebase auth
        const currentUser = auth.currentUser ? auth.currentUser.uid : ""
        setUserId(currentUser)

        // Fetch tournament levels
        const levelsDocs = await fetchCollection("tournamentLevels")
        const levelsLocal = []
        levelsDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const levelObject = {
                label: docData.level,
                value: docData.level
            }
            levelsLocal.push(levelObject)
        });
        setAllLevels(levelsLocal)

         // Fetch tournament sub-levels
        const subLevelsDocs = await fetchCollection("tournamentSubLevels")
        const subLevelsLocal = []
        subLevelsDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const subLevelObject = {
                label: docData.subLevel,
                value: docData.subLevel
            }
            subLevelsLocal.push(subLevelObject)
        });
        setAllSubLevels(subLevelsLocal)

        // Fetch tournament types
        const tournamentTypeListLocal = []
        const tournamentTypeDocs = await fetchCollection("tournamentTypes")
        tournamentTypeDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const golfCourseObject = {
            label: docData.type,
            value: docData.type,
            id: doc.id
            }
            tournamentTypeListLocal.push(golfCourseObject)
        });
        setAllTournamentTypes(tournamentTypeListLocal)

        const associationsListLocal = []
        const associationDocs = await fetchCollection("associations")
        associationDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const associationInfoName = `${docData.name} - ${docData.associationType}`
            const associationObject = {
            label: associationInfoName,
            value: docData.name,
            id: doc.id
            }
            associationsListLocal.push(associationObject)
        });
        setAllAssociations(associationsListLocal)

        // Fetch golf courses
        const golfCourseListLocal = []
        const golfCourseDocs = await fetchCollection("golfCourses")
        golfCourseDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const courseDisplayName = `${docData.name} - ${docData.city}, ${docData.state}`
            const golfCourseObject = {
                label: courseDisplayName,
                value: docData.name,
                name: docData.name,
                city: docData.city,
                state: docData.state,
                country: docData.country,
                id: doc.id
            }
            golfCourseListLocal.push(golfCourseObject)
        });
        setAllGolfCourses(golfCourseListLocal)

        // Fetch all tournaments
        const allTournamentsListLocal = []
        const allTournamentsDocs = await fetchCollection("tournaments")
        allTournamentsDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const tournamentDisplayName = `${docData.tournamentName} @ ${docData.golfCourses[0]}`
            const tournamentObject = {
                label: tournamentDisplayName,
                value: docData.tournamentName,
                id: doc.id
            }
            allTournamentsListLocal.push(tournamentObject)
        })
        setAllTournaments(allTournamentsListLocal)
        setLoading(false)
    }

    const createTournament = async () => {
        setLoading(true)

        const levelsLocal = []
        levels.forEach((level) => {
            levelsLocal.push(level.value)
        })

        const subLevelsLocal = []
        subLevels.forEach((subLevel) => {
            subLevelsLocal.push(subLevel.value)
        })

        const tournamentTypesLocal = []
        tournamentTypes.forEach((tournamentType) => {
            tournamentTypesLocal.push(tournamentType.value)
        })

        const tournamentAssociationsLocal = []
        associations.forEach((association) => {
            tournamentAssociationsLocal.push(association.value)
        })

        const allGolfCourses = []
        const allCities = []
        const allStates = []
        const allCountries = []
        golfCourses.forEach((golfCourse) => {
            allGolfCourses.push(golfCourse.name)
            allCities.push(golfCourse.city)
            allStates.push(golfCourse.state)
            allCountries.push(golfCourse.country)
        })
    
        const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const startDateMonth = month[startDate.getMonth()];
        const startDateDay = startDate.getDate()
        const startDateYear = startDate.getFullYear()
        const startDateString = `${startDateMonth} ${startDateDay}, ${startDateYear}`
        const endDateMonth = month[endDate.getMonth()];
        const endDateDay = endDate.getDate()
        const endDateYear = endDate.getFullYear()
        const endDateString = `${endDateMonth} ${endDateDay}, ${endDateYear}`
    
        // finaly, create new tournament document
    
        const docRef = await addTournamentToDb({
            tournamentName: tournamentName,
            menWomen: menWomen.value,
            tournamentLevels: levelsLocal,
            tournamentSubLevels: subLevelsLocal,
            tournamentTypes: tournamentTypesLocal,
            tournamentAssociations: tournamentAssociationsLocal,
            tournamentPage: tournamentPage,
            golfCourses: allGolfCourses,
            cities: allCities,
            states: allStates,
            countries: allCountries,
            startDate: startDateString,
            endDate: endDateString,
            signupEligibility: signupEligibility,
            qualifierNeeded: qualifierNeeded,
            otherSites: otherSites,
            qualifierFor: qualifierFor,
            qualifiers: qualifiers,
            relatedTournaments: relatedTournaments,
            createdBy: userId,
            createdAt: new Date().toISOString()
        })
        console.log("tournaments document written with ID: ", docRef.id);
        resetForm()
        setLoading(false)
    }

    const resetForm = () => {
        setTournamentName("")
        setGolfCourses([])
        setQualifierNeeded(false)
        setOtherSites([])
        setQualifierFor([])
        setQualifiers([])
        setRelatedTournaments([])
        setTournamentPage("")
        setTournamentTypes([])
        setLevels([])
        setSubLevels([])
        setMenWomen([])
        setSignupEligibility("")
        setAssociations([])
        startDateOnChange(new Date())
        endDateOnChange(new Date())
    }

    const refreshCoursesList = async () => {
        // Fetch golf courses
        const golfCourseListLocal = []
        const golfCourseDocs = await fetchCollection("golfCourses")
        golfCourseDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const courseDisplayName = `${docData.name} - ${docData.city}, ${docData.state}`
            const golfCourseObject = {
            label: courseDisplayName,
            value: docData.name,
            name: docData.name,
            city: docData.city,
            state: docData.state,
            country: docData.country,
            id: doc.id
            }
            golfCourseListLocal.push(golfCourseObject)
        });
        setAllGolfCourses(golfCourseListLocal)
    }

    const refreshAssociationsList = async () => {
        const associationsListLocal = []
        const associationDocs = await fetchCollection("associations")
        associationDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const associationInfoName = `${docData.name} - ${docData.associationType}`
            const associationObject = {
            label: associationInfoName,
            value: docData.name,
            id: doc.id
            }
            associationsListLocal.push(associationObject)
        });
        setAllAssociations(associationsListLocal)
    }

    useEffect(() => {
        setLoading(true)
        fetchData()
    }, []);

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 600 }}>
                <h1 className="admin-login-title">Add Tournament</h1>
                <button
                    className="admin-login-btn"
                    type="button"
                    style={{ marginBottom: "1.5rem", padding: "0.4rem 1.1rem", fontSize: "0.97rem" }}
                    onClick={() => navigate('/admin')}
                >
                    ← Back to Admin Home
                </button>
                <form className="admin-login-form" style={{ gap: "1.5rem" }}>
                    <div>
                        <label className="admin-login-label">Tournament Name</label>
                        <input className="admin-login-input" value={tournamentName} onChange={e => setTournamentName(e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Men/Women</label>
                        <Select isDisabled={false} isMulti={false} menuPlacement='auto' menuPosition='fixed' options={menWomenList} onChange={setMenWomen} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Level(s)</label>
                        <Select isDisabled={false} isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allLevels} onChange={setLevels} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Sub-Level(s)</label>
                        <Select isDisabled={false} isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allSublevels} onChange={setSubLevels} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Type</label>
                        <Select isDisabled={false} isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allTournamentTypes} onChange={setTournamentTypes} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Association(s)</label>
                        <Select isDisabled={false} isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allAssociations} onChange={setAssociations} />
                        <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
                            <Link target="_blank" rel="noopener noreferrer" to="/admin/createNewAssociation">
                                <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem" }}>
                                    Create New Association(s)
                                </button>
                            </Link>
                            <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem", background: "linear-gradient(90deg, #38bdf8 0%, #2563eb 100%)" }} onClick={refreshAssociationsList}>
                                Refresh Associations List
                            </button>
                        </div>
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Web Page</label>
                        <input className="admin-login-input" value={tournamentPage} onChange={e => setTournamentPage(e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Host Course(s)</label>
                        <Select isDisabled={false} isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allGolfCourses} onChange={setGolfCourses} />
                        <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
                            <Link target="_blank" rel="noopener noreferrer" to="/admin/createNewCourse">
                                <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem" }}>
                                    Create New Course
                                </button>
                            </Link>
                            <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem", background: "linear-gradient(90deg, #38bdf8 0%, #2563eb 100%)" }} onClick={refreshCoursesList}>
                                Refresh Courses List
                            </button>
                        </div>
                    </div>
                    <div>
    <label className="admin-login-label">Start Date</label>
    <div className="admin-login-date-row">
        <span className="admin-login-date-icon">
            <svg width="20" height="20" fill="none" stroke="#2563eb" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="3" y="4" width="18" height="18" rx="4" stroke="#2563eb" strokeWidth="2" fill="#f3f6fd"/>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v4M8 2v4M3 10h18"/>
            </svg>
        </span>
        <DatePicker
            onChange={startDateOnChange}
            value={startDate}
            calendarIcon={null}
            clearIcon={null}
            className="admin-login-date-picker"
        />
    </div>
</div>
<div>
    <label className="admin-login-label">End Date</label>
    <div className="admin-login-date-row">
        <span className="admin-login-date-icon">
            <svg width="20" height="20" fill="none" stroke="#2563eb" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="3" y="4" width="18" height="18" rx="4" stroke="#2563eb" strokeWidth="2" fill="#f3f6fd"/>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 2v4M8 2v4M3 10h18"/>
            </svg>
        </span>
        <DatePicker
            onChange={endDateOnChange}
            value={endDate}
            calendarIcon={null}
            clearIcon={null}
            className="admin-login-date-picker"
        />
    </div>
</div>
                    <div>
                        <label className="admin-login-label">Signup Eligibility</label>
                        <input className="admin-login-input" value={signupEligibility} onChange={e => setSignupEligibility(e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifier Needed?</label>
                        <div style={{ marginTop: "0.5rem" }}>
                            <Switch onChange={handleQualifierNeededChange} checked={qualifierNeeded} />
                        </div>
                    </div>
                    <div>
                        <label className="admin-login-label">Other Sites</label>
                        <Select isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allTournaments} onChange={setOtherSites} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifier For</label>
                        <Select isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allTournaments} onChange={setQualifierFor} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifiers</label>
                        <Select isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allTournaments} onChange={setQualifiers} />
                    </div>
                    <div>
                        <label className="admin-login-label">Related Tournaments</label>
                        <Select isMulti={true} menuPlacement='auto' menuPosition='fixed' options={allTournaments} onChange={setRelatedTournaments} />
                    </div>
                    <div style={{ marginTop: "1.5rem" }}>
                        <button className="admin-login-btn" type="button" onClick={createTournament}>
                            Create Tournament
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateTournament;